export interface RenewalBillingProfile {
  id: number
  name?: string | null
  first_name?: string | null
  last_name?: string | null
}

export interface RenewalBillingInfo {
  source: 'override' | 'last_order' | 'fallback' | 'none'
  profile: RenewalBillingProfile | null
  order_id: number | null
}

export function profileLabel(profile: RenewalBillingProfile | null): string {
  if (!profile) return '—'
  if (profile.name) return profile.name
  const person = [profile.first_name, profile.last_name].filter(Boolean).join(' ')
  return person || `profil č. ${profile.id}`
}

export function describeRenewalBillingSource(info: RenewalBillingInfo | null): string {
  if (!info) return 'Nezistené, načítavam…'
  switch (info.source) {
    case 'override':
      return `Nastavený profil: ${profileLabel(info.profile)} (má prednosť)`
    case 'last_order':
      return `Z poslednej uhradenej objednávky č. ${info.order_id ?? '—'}: ${profileLabel(info.profile)}`
    case 'fallback':
      return `Prvý profil používateľa (záloha): ${profileLabel(info.profile)}`
    case 'none':
      return 'Žiadny fakturačný profil — nastavte ho, inak objednávka nevznikne'
  }
}
